import Vue from 'vue'

Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})


// WEBPACK FOOTER //
// ./static-content/public/javascripts/common.ts